import React,{useEffect, useState}from 'react'
import Main from '../../cpn/Main'
import { Table} from 'antd';
import {useBnsFanKuiJianChaListQuery } from '../../store/ReactWebSiteApi';
import FeedbackCheck from './FeedbackCheck';
function FeedbackTask() {       
    const [list, setList] = useState();    
    const {data, isSuccess} = useBnsFanKuiJianChaListQuery();    
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bfkjc_id:key,bfkjc_name,bfkjc_ctime,bfkjc_cname,bfkjc_content,bfkjc_dept_id,bfkjc_dept_name,bfkjc_bg_name,bfkjc_jihuariqi,bfkjc_meijie_name,bfkjc_fuzhuren_name,bfkjc_state} = item;
                    return item = {key,bfkjc_name,bfkjc_ctime,bfkjc_cname,bfkjc_content,bfkjc_dept_id,bfkjc_dept_name,bfkjc_bg_name,bfkjc_jihuariqi,bfkjc_meijie_name,bfkjc_fuzhuren_name,bfkjc_state}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bfkjc_ctime;
                    let bTimeString = b.bfkjc_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'bfkjc_jihuariqi',
            title: '日期',            
            dataIndex:'bfkjc_jihuariqi'
        },
       
        {
            key: 'bfkjc_bg_name',
            title: '产品',            
            dataIndex:'bfkjc_bg_name',
        },
        {
            key: 'bfkjc_meijie_name',
            title: '媒介',            
            dataIndex: 'bfkjc_meijie_name',
            
        },
        {
            key: 'bfkjc_fuzhuren_name',
            title: '负责人',            
            dataIndex: 'bfkjc_fuzhuren_name',
            
        },
         {
            key: 'bfkjc_name',
            title: '检查内容',
            dataIndex:'bfkjc_name',
            render:(_,record) => {
                return  <FeedbackCheck
                            bfkjc_id={record.key}
                            bfkjc_name={record.bfkjc_name}
                        />
            }
        },   
        {
            key: 'bfkjc_state',
            title: '状态',
            dataIndex:'bfkjc_state',
            render:(text) => {
                if(text==='1'){
                    return<>已实现</>
                }else{
                    return<>待实现</>
                }
            }   
        },         
        {
            key: 'num',
            title: '编号',            
            dataIndex: 'key',            
        },
        {
            key: 'bfkjc_dept_name',
            title: '部门',            
            dataIndex: 'bfkjc_dept_name',
            
        },
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.bfkjc_ctime + record.bfkjc_cname}</>
            }
        },
        
    ]   
    return (
        <Main t1='推广'  t2='我的反馈检查任务'>            
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}} 
            />
        </Main>
    )
}

export default FeedbackTask